import React from "react"
import WidgetWrapper from "../../internal/widgetWrapper/WidgetWrapper"
import * as styles from "./VideoWidget.module.scss"

const VideoWidget = ({ blok }) => {
  return (
    <WidgetWrapper blok={blok}>
      <div className={styles.container}>
        <div className={styles.videoWrapper}>
          <iframe
            width="510"
            height="322"
            src={blok.youtube_url}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </WidgetWrapper>
  )
}

export default VideoWidget